import { jsx as _jsx } from "react/jsx-runtime";
import { CancelJob } from "./CancelJob";
import { DeleteJob } from "./DeleteJob";
export function JobActions({ job }) {
    if (job.status == "Completed" || job.status === "Error")
        return _jsx(DeleteJob, { job: job });
    else
        return _jsx(CancelJob, { jobID: job.traceId });
}
